import { errorHandle } from 'redux/actions/error';
import { apiService } from 'shared/services';

import {
  GET_LIST_EMPLOYEE,
  GET_LIST_EMPLOYEE_SUCCESS,
  GET_LIST_EMPLOYEE_FAILED,
  SET_STATUS_EMPLOYEE,
  SET_STATUS_EMPLOYEE_SUCCESS,
  SET_STATUS_EMPLOYEE_FAILED,
  UPDATE_EMPLOYEE_ROLES,
  GET_LIST_ROLES_EMPLOYEE,
  GET_LIST_ROLES_EMPLOYEE_SUCCESS,
  GET_LIST_ROLES_EMPLOYEE_FAILED,
  ACTIVATE_EMPLOYEE_ROLE_SUCCESS,
  DEACTIVATE_EMPLOYEE_ROLE_SUCCESS,
  GET_SINGLE_EMPLOYEE,
  UPDATE_SINGLE_EMPLOYEE_PAYLOAD,
  GET_SINGLE_ROLE_EMPLOYEE,
  UPDATE_SINGLE_ROLE_EMPLOYEE_PAYLOAD,
  INIT_SUBMIT_EDIT_EMPLOYEE,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  UPDATE_EMPLOYEE_SUCCESS,
  UPDATE_EMPLOYEE_ERROR,
  RETRY_USER,
  RETRY_EMPLOYEE,
} from './types';

const { amonraApiService } = apiService.getInstance();

export const getListEmployee = (
  paginationUrl,
  paramUrl = '',
  successCallback,
) => dispatch => {
  dispatch({ type: GET_LIST_EMPLOYEE });

  const url = `employees?${paginationUrl}${paramUrl}`;

  amonraApiService
    .get(url)
    .then(response => {
      dispatch({
        type: GET_LIST_EMPLOYEE_SUCCESS,
        employeeList: response.data.payload,
        pagination: response.data.pagination,
      });

      if (successCallback) {
        successCallback(response.data.pagination);
      }
    })
    .catch(error => {
      dispatch({
        type: GET_LIST_EMPLOYEE_FAILED,
        payload: { employeeList: [] },
      });
      errorHandle(error);
    });
};

export const setEmployeeStatus = (
  id,
  isActivated,
  successCallback,
) => dispatch => {
  dispatch({ type: SET_STATUS_EMPLOYEE, payload: id });
  amonraApiService
    .post(`users/${id}/${isActivated ? 'activate' : 'deactivate'}`)
    .then(() => {
      dispatch({
        type: SET_STATUS_EMPLOYEE_SUCCESS,
      });
      successCallback(isActivated);
    })
    .catch(error => {
      dispatch({
        type: SET_STATUS_EMPLOYEE_FAILED,
      });
      errorHandle(error);
    });
};

export const getSingleEmployee = (employeeId, callback) => dispatch => {
  dispatch({ type: GET_SINGLE_EMPLOYEE });
  amonraApiService
    .get(`employees/${employeeId}`)
    .then(response => {
      dispatch({
        type: UPDATE_SINGLE_EMPLOYEE_PAYLOAD,
        payload: response.data,
      });
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      dispatch({
        type: UPDATE_SINGLE_EMPLOYEE_PAYLOAD,
        payload: '',
        error: error.data,
      });
    });
};

export const updateEmployeeRoles = newRoles => ({
  type: UPDATE_EMPLOYEE_ROLES,
  payload: newRoles,
});

export const updateEmployeeRolesAll = (rolesAll, pagination) => ({
  type: GET_LIST_ROLES_EMPLOYEE_SUCCESS,
  employeeRolesAll: rolesAll,
  pagination,
});

export const getEmployeeRole = (
  paginationUrl,
  paramUrl = '',
  successCallback,
) => dispatch => {
  dispatch({ type: GET_LIST_ROLES_EMPLOYEE });

  const url = `roles?${paginationUrl}${paramUrl}`;

  amonraApiService
    .get(url)
    .then(response => {
      if (successCallback) {
        successCallback(response.data);
      } else {
        dispatch(
          employee.updateEmployeeRolesAll(
            response.data.payload,
            response.data.pagination,
          ),
        );
      }
    })
    .catch(error => {
      dispatch({
        type: GET_LIST_ROLES_EMPLOYEE_FAILED,
        payload: { employeeRoleList: [] },
      });
      errorHandle(error);
    });
};

export const activateEmployeeRole = (id, callback) => dispatch => {
  amonraApiService
    .post(`roles/${id}/activate`)
    .then(response => {
      if (response.status === 204) {
        dispatch({ type: ACTIVATE_EMPLOYEE_ROLE_SUCCESS });
        callback(false);
      }
    })
    .catch(error => {
      errorHandle(error);
    });
};

export const deactivateEmployeeRole = (id, callback) => dispatch => {
  amonraApiService
    .post(`roles/${id}/deactivate`)
    .then(response => {
      if (response.status === 204) {
        dispatch({ type: DEACTIVATE_EMPLOYEE_ROLE_SUCCESS });
        callback(true);
      }
    })
    .catch(error => {
      errorHandle(error);
    });
};

export const registerEmployeeRole = (
  params,
  successCallback,
  errorCallback,
) => () => {
  amonraApiService
    .post(`roles`, params)
    .then(response => {
      if (response.status === 200) {
        successCallback();
      }
    })
    .catch(error => {
      errorCallback();
      errorHandle(error);
    });
};

export const updateEmployeeRole = (
  roleId,
  params,
  successCallback,
  errorCallback,
) => () => {
  amonraApiService
    .patch(`roles/${roleId}`, params)
    .then(response => {
      if (response.status === 200) {
        successCallback();
      }
    })
    .catch(error => {
      errorCallback();
      errorHandle(error);
    });
};

export const getSingleEmployeeRole = (roleId, successCallback) => dispatch => {
  dispatch({ type: GET_SINGLE_ROLE_EMPLOYEE });
  amonraApiService
    .get(`roles/${roleId}`)
    .then(response => {
      dispatch({
        type: UPDATE_SINGLE_ROLE_EMPLOYEE_PAYLOAD,
        payload: response.data,
      });
      if (successCallback) {
        successCallback(response.data);
      }
    })
    .catch(error => {
      dispatch({
        type: UPDATE_SINGLE_ROLE_EMPLOYEE_PAYLOAD,
        payload: '',
        error: error.data,
      });
    });
};

export const updateEmployee = params => dispatch => {
  dispatch(employee.initSubmitEditEmployee(params));

  employee.startUpdateUser(dispatch, params);
};

export const initSubmitEditEmployee = params => ({
  type: INIT_SUBMIT_EDIT_EMPLOYEE,
  params,
});

export const startUpdateUser = (dispatch, params) => {
  amonraApiService
    .patch(`users/${params.user_id}`, params.user)
    .then(employee.onUpdateUserSuccess(dispatch, params))
    .catch(employee.onUpdateUserError(dispatch));
};

export const onUpdateUserSuccess = (dispatch, params) => response => {
  params.employee.user_id = response.data.payload.user_id;
  dispatch(employee.updateUserSuccess(params));

  employee.startUpdateEmployee(dispatch, params);
};
export const updateUserSuccess = params => ({
  type: UPDATE_USER_SUCCESS,
  params,
});

export const onUpdateUserError = dispatch => () => {
  dispatch(employee.updateUserError());
};
export const updateUserError = () => ({
  type: UPDATE_USER_ERROR,
});

export const startUpdateEmployee = (dispatch, params) => {
  amonraApiService
    .patch(`employees/${params.employee_id}`, params.employee)
    .then(employee.onUpdateEmployeeSuccess(dispatch, params))
    .catch(employee.onUpdateEmployeeError(dispatch));
};

export const onUpdateEmployeeSuccess = (dispatch, params) => () => {
  if (params.avatar) {
    employee.startUploadEmployeeImage(dispatch, params);
  } else {
    dispatch(employee.updateEmployeeSuccess(params));
  }
};
export const updateEmployeeSuccess = params => ({
  type: UPDATE_EMPLOYEE_SUCCESS,
  params,
});

export const onUpdateEmployeeError = dispatch => () => {
  dispatch(employee.updateEmployeeError());
};
export const updateEmployeeError = () => ({
  type: UPDATE_EMPLOYEE_ERROR,
});

export const startUploadEmployeeImage = (dispatch, params) => {
  const urlPath = `users/${params.employee.user_id}/avatar`;

  const formData = new FormData();
  formData.append('document', params.avatar);

  amonraApiService
    .post(urlPath, formData)
    .then(employee.onUploadUserImageSuccess(dispatch, params))
    .catch(employee.onUploadUserImageError(dispatch, params));
};

export const onUploadUserImageSuccess = (dispatch, params) => () => {
  dispatch(employee.updateEmployeeSuccess(params));
};

export const onUploadUserImageError = (dispatch, params) => () => {
  dispatch(employee.updateEmployeeSuccess(params));
};

export const startRetryUpdateUser = params => dispatch => {
  dispatch(employee.retryUser());

  employee.startUpdateUser(dispatch, params);
};

export const startRetryUpdateEmployee = params => dispatch => {
  dispatch(employee.retryEmployee());

  employee.startUpdateEmployee(dispatch, params);
};

export const retryUser = () => ({
  type: RETRY_USER,
});

export const retryEmployee = () => ({
  type: RETRY_EMPLOYEE,
});

const employee = {
  updateEmployee,
  startUpdateUser,
  initSubmitEditEmployee,
  onUpdateUserSuccess,
  onUpdateUserError,
  updateUserSuccess,
  updateUserError,
  startUpdateEmployee,
  onUpdateEmployeeSuccess,
  updateEmployeeSuccess,
  onUpdateEmployeeError,
  updateEmployeeError,
  startUploadEmployeeImage,
  retryUser,
  retryEmployee,
  updateEmployeeRoles,
  startRetryUpdateEmployee,
  startRetryUpdateUser,
  onUploadUserImageSuccess,
  onUploadUserImageError,
  updateEmployeeRolesAll,
};

export default employee;
